<template>
  <div id="app">
    <header>
      <top-bar v-if="loggedIn" />
    </header>
    <div>
      <progress-bar />
      <busy-indicator :position="'absolute'" />
    </div>
    <div v-bind:class="['app-container', { 'app-container-margin': loggedIn }]">
      <div class="view-container">
        <canvas id="confetti-canvas"></canvas>
        <router-view />
      </div>
      <template v-if="loggedIn">
        <right-panel />
      </template>
    </div>
    <footer id="build-number">
      <div class="float-right px-2">
        &copy; Ameriflex Benefits Solutions. All rights reserved {{ buildNumber }}
      </div>
      <div id="status" class="float-right px-2" style="display: none"></div>
    </footer>
    <amf-help-hint-icon></amf-help-hint-icon>
  </div>
</template>

<script>
import TopBar from './framework/TopBar'
import RightPanel from './framework/RightPanel'
import ActionItems from './action-items/ActionItems'
import { config } from './config'
import claimsIpc from './dashboards/claims-ipc'
import GoogleAuth from './framework/GoogleAuth'
import { amfDebug } from './framework/utils/amf-debug'
import { appVersion } from './framework/utils/app-version'
import ProgressBar from "./framework/primitives/ProgressBar";
import AmfHelpHintIcon from './framework/primitives/AmfHelpHintIcon.vue'

export default {
  name: 'App',
  components: {ProgressBar, TopBar, RightPanel, AmfHelpHintIcon },
  data() {
    return {
      buildNumber: config.buildNumber
    }
  },
  methods: {
    ...amfx.map('session', "sessionInit:init")
  },
  computed: {
    ...amfx.map('session', 'loggedIn')
  },
  created() {
    if(GoogleAuth.isGsuiteUser()) {
      amfDebug.login.init();
    }
    claimsIpc.init();
    this.sessionInit();
  },
  watch: {
    $route(to, from) {
      appVersion.checkForUpdates().then(result => {
        if(result) window.location.reload(true);
      });
    }
  },
}
</script>

<style lang="scss">
  @import './scss/amf-bootstrap.scss';
  @import './scss/index.scss';
  @import './scss/new-style.scss';
  #confetti-canvas {
    position: fixed;
    z-index: 1;
    pointer-events: none;
    left: 0;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue